import React, { useState, useMemo } from 'react';

const FavoritesList = ({ favorites, onRemoveFromFavorites, darkMode }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('');
  const [sortBy, setSortBy] = useState('date');

  const filteredAndSortedFavorites = useMemo(() => {
    let filtered = favorites.filter(favorite => {
      const matchesSearch = favorite.text.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory = filterCategory === '' || favorite.category === filterCategory;
      return matchesSearch && matchesCategory;
    });

    return filtered.sort((a, b) => {
      switch (sortBy) {
        case 'date':
          return new Date(b.date) - new Date(a.date);
        case 'category':
          return a.category.localeCompare(b.category);
        case 'text':
          return a.text.localeCompare(b.text);
        default:
          return 0;
      }
    });
  }, [favorites, searchTerm, filterCategory, sortBy]);

  const categories = [...new Set(favorites.map(fav => fav.category))];

  return (
    <div className="favorites-container">
      <div className="favorites-filters">
        <div className="search-box">
          <input
            type="text"
            placeholder="🔍 Hľadať v citátoch..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        
        <div className="filter-controls">
          <select
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
            className="filter-select"
          >
            <option value="">Všetky kategórie</option>
            {categories.map(category => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
          
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="filter-select"
          >
            <option value="date">Zoradiť podľa dátumu</option>
            <option value="category">Zoradiť podľa kategórie</option>
            <option value="text">Zoradiť podľa textu</option>
          </select>
        </div>
      </div>

      <div className="favorites-stats">
        <span className="result-count">
          {filteredAndSortedFavorites.length} z {favorites.length} citátov
        </span>
      </div>

      <div className="favorites-grid">
        {filteredAndSortedFavorites.map(favorite => (
          <div key={favorite.id} className="favorite-card">
            <p className="favorite-quote">"{favorite.text}"</p>
            <div className="favorite-meta">
              <span className="favorite-category">{favorite.category}</span>
              <span className="favorite-date">{favorite.date}</span>
            </div>
            <button 
              onClick={() => onRemoveFromFavorites(favorite.id)}
              className="remove-button"
              title="Odstrániť z obľúbených"
            >
              🗑️
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FavoritesList;
